export default __webpack_public_path__ + "static/media/hobbies.5d626a0a.jpg";